import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconClock } from "@tabler/icons-react";
import { Alert, Button, Group, PageHeader, Stack } from "@/components/ui";
import { LayoutConStepper, PASO_PAGE_SHELL } from "@/components/ui/solicitud-stepper";
import { PolizasCard } from "./PolizasCard";
import { useSolicitud } from "@/features/solicitudes/hooks/use-solicitud";
import { useSolicitudPolling } from "@/features/solicitudes/hooks/use-solicitud-polling";
import { Route } from "@/routes/_authed-tw/solicitudes/$id/contabilizacion";

/**
 * Pantalla del paso "Contabilización" · compone PageHeader + stepper +
 * `<PolizasCard>` (lista de pólizas TXT) o un alert mientras la póliza
 * todavía no se genera (corre en paralelo a autorización · decisión sprint 5).
 */
export function ContabilizacionPasoPage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data: sol } = useSolicitud(id);
  useSolicitudPolling(id, 5_000);

  const polizaGenerada = sol.enviadaAContabilizacion;

  return (
    <div className="w-full px-4 py-6 md:px-6" style={PASO_PAGE_SHELL}>
      <PageHeader
        title="Contabilización"
        description={`Solicitud #${sol.numeroSolicitud} · pólizas TXT depositadas en SFTP`}
        breadcrumbs={[
          { label: "Inicio", href: "/dashboard" },
          { label: "Solicitudes", href: "/solicitudes" },
          { label: `#${sol.numeroSolicitud}`, href: `/solicitudes/${id}` },
          { label: "Contabilización" },
        ]}
      />
      <LayoutConStepper
        estado={sol.estado}
        subtipo={sol.subtipo}
        tipo={sol.tipo}
        paso="contabilizacion"
        solicitudId={id}
        contabilizada={sol.enviadaAContabilizacion}
        fillHeight
      >
        <Stack gap="md">
          {polizaGenerada ? (
            <PolizasCard solicitudId={id} />
          ) : (
            <Alert variant="info" icon={<IconClock size={16} stroke={1.7} />}>
              La póliza aún no se ha generado · la contabilización corre en
              paralelo al flujo de autorización. Vuelve a revisar en unos
              segundos.
            </Alert>
          )}
          <Group justify="space-between" className="mt-2">
            <Button
              variant="default"
              leftSection={<IconArrowLeft size={14} />}
              onClick={() => navigate({ to: "/solicitudes/$id", params: { id }, replace: true })}
            >
              Volver al detalle
            </Button>
          </Group>
        </Stack>
      </LayoutConStepper>
    </div>
  );
}
